let cachedHostTakeover: boolean | null = null;

function parseBooleanFlag(value: unknown): boolean | null {
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (['1', 'true', 'yes', 'on', 'enabled'].includes(normalized)) {
      return true;
    }
    if (['0', 'false', 'no', 'off', 'disabled'].includes(normalized)) {
      return false;
    }
  }
  if (typeof value === 'number') {
    if (value === 1) return true;
    if (value === 0) return false;
  }
  return null;
}

export function resolveHostTakeoverEnabled(): boolean {
  if (cachedHostTakeover !== null) {
    return cachedHostTakeover;
  }

  const metaEnv = typeof import.meta !== 'undefined' ? import.meta.env : undefined;
  const processEnv = typeof process !== 'undefined' ? process.env : undefined;

  const envValue = metaEnv?.VITE_ENABLE_HOST_TAKEOVER ?? processEnv?.VITE_ENABLE_HOST_TAKEOVER;
  const envParsed = parseBooleanFlag(envValue);
  if (envParsed !== null) {
    cachedHostTakeover = envParsed;
    return cachedHostTakeover;
  }

  if (typeof window !== 'undefined') {
    const globalFlag = window.__HOST_TAKEOVER_ENABLED__;
    const globalParsed = parseBooleanFlag(globalFlag);
    if (globalParsed !== null) {
      cachedHostTakeover = globalParsed;
      return cachedHostTakeover;
    }

    let searchValue: string | null = null;
    try {
      const search = window.location?.search ?? '';
      if (search) {
        const params = new URLSearchParams(search);
        searchValue = params.get('hostTakeover');
      }
    } catch {
      searchValue = null;
    }

    const searchParsed = parseBooleanFlag(searchValue);
    if (searchParsed !== null) {
      cachedHostTakeover = searchParsed;
      return cachedHostTakeover;
    }
  }

  cachedHostTakeover = false;
  return cachedHostTakeover;
}

export function overrideHostTakeoverEnabled(value: boolean | null) {
  cachedHostTakeover = value;
}
